import "./AboutMe.module.css";
import Header from "@/reusable_sections/Header";
import Meet from "./sections/Meet";
import Philosophy from "./sections/Philosophy";
import Values from "./sections/Values";
import Footer from "@/reusable_sections/Footer";
export default function AboutMePage() {
  return <div>
      <Header />
      <Meet />
      <Philosophy />
      <Values />
      <Footer />
    </div>;
}